import {
  REFERENTIAL_AUTOVISTA_FR,
  REFERENTIAL_SANGUINETTI_IT,
  isReferentialAutovista
} from './enums/referential'

const getEquipmentGroupings = (equipmentGroups, item, referential = REFERENTIAL_AUTOVISTA_FR) => {
  let carEquipmentGroupings = null
  if (isReferentialAutovista(referential) || referential === REFERENTIAL_SANGUINETTI_IT) {
    const filteredEquipementGroup = equipmentGroups.filter(group =>
      item.equipmentGroups.includes(group.id)
    )

    carEquipmentGroupings = item.equipmentSubGroups.map(sub => {
      const res = filteredEquipementGroup
        .filter(group => group.equipmentSubGroups.filter(el => el.id === sub).length > 0)
        .map(group => ({
          groupId: group.id,
          group: group.group,
          code: group.code,
          ...(() => {
            const result = group.equipmentSubGroups.find(subGroup => subGroup.id === sub)
            return {
              subgroup: result.subGroup,
              subgroupId: result.id
            }
          })()
        }))

      return res
    })
  }

  return carEquipmentGroupings
}

export default getEquipmentGroupings
